import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="yellow">Sumit Ranjan </span>
            from <span className="yellow"> Karnataka, India.</span>
            <br /> I've completed my B.tech in Electrical and Eletronics
            Enggineering from Uttar Pradesh Technical University.
            <br />
            Additionally, I am currently employed as a Application Development
            Associate Mgr. at Accenture
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing PC Games
            </li>
            <li className="about-activity">
              <ImPointRight /> cooking
            </li>
            <li className="about-activity">
              <ImPointRight /> Gardening
            </li>
            <li className="about-activity">
              <ImPointRight /> Aquarium Aquascape
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "If we want to change things, we must first change ourselves!"{" "}
          </p>
          <footer className="blockquote-footer">Paul Rusesabagina</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
